import { useEffect, useState } from "react";
import { getChargingHistory } from "../services/apiService";

export const AMOUNT_POLL_MS = 30 * 1000;
export const AMOUNT_MAX_ATTEMPTS = 10;

// Montant débité d'une recharge terminée (écran 1e).
//
// Le montant n'existe qu'une fois la recharge valorisée par Qobilling : d'ici là,
// l'historique renvoie un prix à 0. On relit l'historique quelques minutes, puis
// on s'arrête : le montant reste alors « en cours de calcul » et figurera sur le
// justificatif envoyé par e-mail.
export default function useChargeAmount({ transactionId, accessToken, enabled }) {
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (!enabled || !transactionId) return undefined;

    let stopped = false;
    let timer = null;
    let attempts = 0;

    const fetchAmount = async () => {
      attempts += 1;
      try {
        const history = await getChargingHistory(accessToken);
        if (stopped) return;

        const charge = history?.results?.find((item) => item.transactionId === transactionId);
        const price = Number(charge?.price);
        if (price > 0) {
          setAmount(price);
          return;
        }
      } catch (error) {
        // Erreur passagère : on retentera au prochain passage.
      }

      if (!stopped && attempts < AMOUNT_MAX_ATTEMPTS) {
        timer = setTimeout(fetchAmount, AMOUNT_POLL_MS);
      }
    };

    fetchAmount();

    return () => {
      stopped = true;
      clearTimeout(timer);
    };
  }, [enabled, transactionId, accessToken]);

  return amount;
}
